// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_2np8o","text":"index_text_RbU8X","textHidden":"index_textHidden_1WsQ2","contentBox":"index_contentBox_3AovF","boxTitle":"index_boxTitle_2CgCX"};